import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useEffect, useState, useRef } from 'react';
import { getInitCheckededKeys, getDataCheckededStateStrictly, getInitExpandedKeys, getPos, getAllParentKeys } from './utils/treeUtils';
export var useViewportHeight = function useViewportHeight(height, listRef) {
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewportHeight = _React$useState2[0],
    setViewportHeight = _React$useState2[1];
  React.useEffect(function () {
    height ? setViewportHeight(height) : listRef.current && setViewportHeight(listRef.current.clientHeight);
  }, [listRef, height]);
  return [viewportHeight];
};
export var useVisibleDataMemo = function useVisibleDataMemo(virtual, filterData, viewportHeight, estimatedItemSize, start) {
  var visibledCount = React.useMemo(function () {
    return Math.ceil(viewportHeight / estimatedItemSize);
  }, [viewportHeight, estimatedItemSize]);
  var viewportData = React.useMemo(function () {
    return _sliceInstanceProperty(filterData).call(filterData, start, start + visibledCount);
  }, [filterData, start, visibledCount]);
  var visibleData = React.useMemo(function () {
    return virtual ? viewportData : filterData;
  }, [virtual, viewportData, filterData]);
  return [visibleData];
};
export var usePlantomHeightEffect = function usePlantomHeightEffect(plantomRef, filterData, estimatedItemSize) {
  React.useEffect(function () {
    var height = filterData.length * estimatedItemSize;
    if (plantomRef.current) {
      plantomRef.current.style.height = height + 'px';
    }
  }, [plantomRef, filterData, estimatedItemSize]);
};
export var useChecked = function useChecked(checkStrictly, checkedKeysProps, defaultCheckedKeys, _flattenAllData, _maxLevel, checkable, keysData) {
  var initialCheckedState = React.useMemo(function () {
    if (!checkable) return {
      checkedKeys: [],
      halfCheckedKeys: []
    };
    return checkStrictly ? getDataCheckededStateStrictly(checkedKeysProps || defaultCheckedKeys) : getInitCheckededKeys(checkedKeysProps || defaultCheckedKeys, keysData);
  }, [checkable, checkStrictly, checkedKeysProps, defaultCheckedKeys, keysData]);
  var _React$useState3 = React.useState(initialCheckedState.checkedKeys),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    checkedKeys = _React$useState4[0],
    setCheckedKeys = _React$useState4[1];
  var _React$useState5 = React.useState(initialCheckedState.halfCheckedKeys),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    halfCheckedKeys = _React$useState6[0],
    setHalfCheckedKeys = _React$useState6[1];
  var nextCheckedKeys = initialCheckedState.checkedKeys;
  var nextHalfCheckedKeys = initialCheckedState.halfCheckedKeys;
  useEffect(function () {
    setCheckedKeys(nextCheckedKeys);
  }, [nextCheckedKeys]);
  useEffect(function () {
    setHalfCheckedKeys(nextHalfCheckedKeys);
  }, [nextHalfCheckedKeys]);
  return [checkedKeys, halfCheckedKeys, setCheckedKeys, setHalfCheckedKeys];
};
export var useExpand = function useExpand(flattenAllData, expandedKeysProps, defaultExpandedKeys, defaultExpandAll, defaultExpandRoot, defaultExpandParent, scrollKey, isInit, filterTreeNode, isSearching, keysData, searchStatus) {
  var expandScrollkeys = [];
  if (scrollKey) {
    var pos = getPos(flattenAllData, scrollKey);
    expandScrollkeys = getAllParentKeys(flattenAllData, pos);
  }
  var initialExpandedKeys = React.useMemo(function () {
    return getInitExpandedKeys(flattenAllData, expandedKeysProps, defaultExpandedKeys, defaultExpandAll, defaultExpandRoot, defaultExpandParent, expandScrollkeys, filterTreeNode, isSearching, keysData, isInit, searchStatus);
  }, [flattenAllData, expandedKeysProps, defaultExpandedKeys, defaultExpandAll, defaultExpandRoot, defaultExpandParent, scrollKey, filterTreeNode, isSearching, keysData, isInit, searchStatus]);
  var _React$useState7 = React.useState(initialExpandedKeys),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    expandedKeys = _React$useState8[0],
    setExpandedKeys = _React$useState8[1];
  React.useEffect(function () {
    setExpandedKeys(initialExpandedKeys);
  }, [flattenAllData, expandedKeysProps, defaultExpandAll, defaultExpandedKeys, defaultExpandRoot, defaultExpandParent, scrollKey, searchStatus]);
  return [expandedKeys, setExpandedKeys];
};
export var useScrollToKey = function useScrollToKey(scrollKey, index, estimatedItemSize, scrollRef, viewportHeight, treeNodePrefixCls) {
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    scroll = _React$useState10[0],
    setScroll = _React$useState10[1];
  useEffect(function () {
    setScroll(true);
  }, [scrollKey]);
  useEffect(function () {
    var _context;
    if (!scroll) return;
    var treeRoot = scrollRef.current;
    var treeNode = treeRoot === null || treeRoot === void 0 ? void 0 : treeRoot.getElementsByClassName(_concatInstanceProperty(_context = "".concat(treeNodePrefixCls, "-item-")).call(_context, scrollKey))[0];
    if (!scrollKey) {
      setScroll(false);
      return;
    }
    if (treeRoot && treeNode) {
      var treeRootRect = treeRoot.getBoundingClientRect();
      var treeNodeRect = treeNode.getBoundingClientRect();
      if (treeRootRect.top <= treeNodeRect.top && treeRootRect.bottom >= treeNodeRect.bottom) {
        setScroll(false);
        return;
      }
    }
    var _index = index;
    var visibleDataLength = Math.ceil(viewportHeight / estimatedItemSize);
    var halfVisibleIndex = Math.floor(visibleDataLength / 2);
    _index = _index - halfVisibleIndex;
    scrollRef.current.scrollTop = _index * estimatedItemSize;
    setScroll(false);
  }, [scroll, index, viewportHeight, estimatedItemSize]);
};
export var useSelect = function useSelect(selectedKeysProps, defaultSelectedKeys) {
  var _useState = useState(selectedKeysProps || defaultSelectedKeys),
    _useState2 = _slicedToArray(_useState, 2),
    selectedKeys = _useState2[0],
    setSelectedKeys = _useState2[1];
  var mounting = useRef(true);
  useEffect(function () {
    if (mounting.current) {
      mounting.current = false;
      return;
    }
    setSelectedKeys(selectedKeysProps);
  }, [selectedKeysProps]);
  return [selectedKeys, setSelectedKeys];
};